import {BackendEndpoints} from './BackendEndpoints'

type ApiVersion = BackendEndpoints.V1 | BackendEndpoints.V2

const API_VERSION_PATTERN = /^v\d+$/

export const getApiBaseFromBackendUrl = (
    backendUrl: string,
    apiVersion: ApiVersion
): string => {
    if (!backendUrl) {
        return ''
    }

    const url = new URL(backendUrl)
    const pathSegments = url.pathname.split('/').filter(Boolean)
    const apiIndex = pathSegments.findIndex(
        (segment, index) =>
            segment === BackendEndpoints.API &&
            API_VERSION_PATTERN.test(pathSegments[index + 1] || '')
    )

    if (apiIndex === -1) {
        return `${url.origin}/${BackendEndpoints.API}/${apiVersion}`
    }

    return `${url.origin}/${pathSegments
        .slice(0, apiIndex + 1)
        .concat(apiVersion)
        .join('/')}`
}
